// extracted by mini-css-extract-plugin
export default {"fields":"fields-VVZw5","column":"column-fb8KZ","description":"description-hzR7e","comboBox":"comboBox-CZcov"};